export const MOBILE = "MOBILE";
export const TABLET = "TABLET";
export const DESKTOP = "DESKTOP";
